import React from "react";
import { Modal } from "pepsico-ds";

// Modal explaining the regional groupings (EMEA/LATAM/North America/APAC) used by
// the Sector filter. Shared between SmartCubeSource and NewsOverview - controlled
// by the caller via showModal/onCloseModal; the icon trigger stays with the caller.
const SectorDefinitionsModal = ({ showModal, onCloseModal }) => {
  if (!showModal) return null;

  return (
    <Modal
      onCloseModal={onCloseModal}
      primaryButtonProps={{
        onClick: onCloseModal,
        size: "medium",
        text: "Close",
        variant: "primary",
      }}
      showPrimaryButton={true}
      showLink={false}
      showSecondaryButton={false}
      showTertiaryButton={false}
      showAuxiliaryButton={false}
      showSlot={true}
      showModal={showModal}
      closeOnOutsideClick={false}
      hideCloseButton={false}
      type="S"
      title="SmartCube Sector Definitions:"
    >
      <div className="regional-container">
        {/* EMEA Section */}
        <div className="region-title">EMEA (Europe, Middle East, and Africa)</div>
        <ul className="region-list">
          <li className="region-list-item">
            <span className="bold-label">Europe:</span> Includes Western, Eastern, Central, and Southern European countries such as Germany, France, the United Kingdom, Italy, and Russia.
          </li>
          <li className="region-list-item">
            <span className="bold-label">Middle East:</span> Includes countries in the Gulf Cooperation Council (GCC) such as Saudi Arabia, UAE, Qatar, as well as others like Israel, Turkey, and Iran.
          </li>
          <li className="region-list-item">
            <span className="bold-label">Africa:</span> Covers the entire African continent, including countries in Sub-Saharan Africa and North Africa like South Africa, Egypt, and Nigeria.
          </li>
        </ul>

        {/* LATAM Section */}
        <div className="region-title">LATAM (Latin America)</div>
        <ul className="region-list">
          <li className="region-list-item">
            <span className="bold-label">South America:</span> Brazil, Argentina, Chile, Colombia, and Peru
          </li>
          <li className="region-list-item">
            <span className="bold-label">Central America:</span> Mexico, Panama, Costa Rica, and Guatemala
          </li>
          <li className="region-list-item">
            <span className="bold-label">Caribbean:</span> Dominican Republic, Cuba, and Puerto Rico
          </li>
        </ul>

        {/* North America Section */}
        <div className="region-title">North America</div>
        <ul className="region-list">
          <li className="region-list-item">United States</li>
          <li className="region-list-item">Canada</li>
        </ul>

        {/* APAC Section */}
        <div className="region-title">APAC (Asia-Pacific)</div>
        <ul className="region-list">
          <li className="region-list-item">
            <span className="bold-label">East Asia:</span> China, Japan, South Korea, Taiwan, and Hong Kong
          </li>
          <li className="region-list-item">
            <span className="bold-label">Southeast Asia:</span> Singapore, Thailand, Malaysia, Indonesia, Philippines, and Vietnam
          </li>
          <li className="region-list-item">
            <span className="bold-label">South Asia:</span> India, Pakistan, Bangladesh, and Sri Lanka
          </li>
          <li className="region-list-item">
            <span className="bold-label">Oceania:</span> Australia, New Zealand, and Pacific island nations
          </li>
        </ul>
      </div>
    </Modal>
  );
};


export default SectorDefinitionsModal;
